"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaterialToolBar = void 0;
const Toolbar_1 = require("material-ui/Toolbar");
const react_1 = require("react");
const React = require("react");
class MaterialToolBar extends react_1.Component {
    render() {
        const { children } = this.props;
        return React.createElement(Toolbar_1.default, null, children);
    }
}
exports.MaterialToolBar = MaterialToolBar;



//////////////////
// WEBPACK FOOTER
// ./src/client/components/material/toolbar/toolbar.tsx
// module id = 3412
// module chunks = 0